import React, { useMemo } from 'react';
import { ModalDeleteFileProps } from './types';
import { Button } from '@vtbhome/juicyfront';
import { Body, Footer, Subscription } from './modal-delete-file.styles';
import { Typography } from '../../../../../shared/ui/typography/typography';
import { CACHE_KEY_FILE_DELETE } from '../../config/api-constants';
import { useFileDeleteMutation } from '../../api/file-delete-api';
import { File } from '@shared/ui/file/file';
import { InputFileValue } from '@shared/ui/input-file/types';
import { Modal } from '@shared/ui/modal/modal';

export const ModalDeleteFile: React.FC<ModalDeleteFileProps> = ({ isShow, file, onClose, onAccept }) => {
    const [deleteFile, deleteFileResult] = useFileDeleteMutation({ fixedCacheKey: CACHE_KEY_FILE_DELETE });
    const isLoading = deleteFileResult.isLoading;

    const uploadedFile = useMemo(() => {
        return { url: file.url } as InputFileValue['uploadedFiles'][number];
    }, [file.url]);

    const handleAccept = async () => {
        await deleteFile(file.id);
        onAccept();
    };

    return (
        <Modal
            isShow={isShow}
            size='l'
            showLine={false}
            header={<Typography size='h5'>Удаление файла</Typography>}
            footer={
                <Footer>
                    <Button disabled={isLoading} buttonType='light' onClick={onClose}>
                        Отменить
                    </Button>
                    <Button preloader={isLoading} disabled={isLoading} buttonType='primary' onClick={handleAccept}>
                        Подтвердить
                    </Button>
                </Footer>
            }
            onClose={onClose}>
            <Body>
                <Subscription size='body1_long'>Вы уверены что хотите удалить файл?</Subscription>
                <File
                    uploadedFile={{
                        url: uploadedFile?.url,
                        id: file?.id,
                        name: file?.name,
                        extension: file?.meta?.extension,
                        size: file?.meta?.size,
                    }}
                />
            </Body>
        </Modal>
    );
};
